import VueI18n from "vue-i18n";
import * as hiLinkDefault from "../../static/js/default.js";
import zh from "./zh";
import hk from "./zh_hk.js";
import en from "./en";
import ko from "./ko";
import fi from "./fi";
import ja from "./ja";
import de from "./de";
import it from "./it";
import th from "./th";
import ar from "./ar";
import pl from "./pl";
import ru from "./ru";
import vi from "./vi";
import cs from "./cs";
import fr from "./fr";
import es from "./es";
import pt from "./pt";


// 国际化
const i18n = new VueI18n({
  locale: hiLinkDefault.medical.language || getUrl(),
  silentFallbackWarn: true,
  messages: {
    zh: zh, // 中文语言包
    hk: hk, // 中国香港繁体
    en: en, // 英文语言包
    ja: ja, // 日语语言包
    ko: ko, // 韩文语言包
    fi: fi, // 芬兰语语言包
    th: th, // 泰语语言包
    de: de, // 德语语言包
    it: it, // 意大利语语言包
    ar: ar, // 阿拉伯语言包
    pl: pl, // 波兰语言包
    ru: ru, // 俄语语言包
    vi: vi, // 越南语言包
    cs: cs, // 捷克语言包
    fr: fr, // 法语语言包
    es: es, // 西班牙语言包
    pt: pt, // 葡萄牙语言包
  }
});
function getUrl() {
  var url = navigator.language;
  return hiLinkDefault.getUrl(url);
}
export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js